import React from "react";
import {isBetweenDates} from "../common/utils";
import Popover from "react-bootstrap/Popover";
import {OverlayTrigger} from "react-bootstrap";

const FooterLinkB2b = ({link, is_b2b}) => {
    if(is_b2b && isBetweenDates(link.available_between[0], link.available_between[1])){
        return (
            <li>
                <a className="footer-nav-container__link"
                   href={link.url}
                   data-type="link"
                   target={link.target ? link.target : "_self"}
                >
                    {link.label}
                </a>
            </li>
        )
    }

    return (
        <li>
            <OverlayTrigger
                rootClose
                placement={"bottom"}
                trigger={'click'}
                overlay={
                    <Popover id={`tooltip-wholesale`}>
                        <Popover.Content>
                            {is_b2b ? link.b2b_message : link.regular_message}
                        </Popover.Content>
                    </Popover>
                }
            >
                <div
                    id={link.id}
                    className="footer-nav-container__link"
                    data-type="link"
                >
                    {link.label}
                </div>
            </OverlayTrigger>
        </li>
    )
}

export default FooterLinkB2b;